import { awsApiInstance } from '../api/aws-api';

import { ICardGroupInsert, ICardGroupPost } from '../models/cardgroup.interface';
import { handleRouteError } from './route-helpers/route-error';

/**
 * Post new card group form data
 * 
 * @param {ICardGroupInsert} group the form data
 * 
 * @returns {ICardGroupPost} the api response | error
 */
const AwsPostNewCardGroup = async (group: ICardGroupInsert): Promise<ICardGroupPost> => {
  try {
    const { data } = await awsApiInstance.post('/card-group', group);

    return data;
  } catch ( error ) {
    handleRouteError(error, 'Error creating new card group');
    throw(error);
  }
}

export default AwsPostNewCardGroup;